import React from 'react'
import './home.css';
import {Sec1, Sec2, Sec3, Sec4 } from '../../components' ;

function Home () {
  return (
    <div>
      <Sec1/>
      <Sec2/>
      <Sec3/>
      <Sec4/>
    </div>
  )
}

export default Home;